import { createTimes, setMidnight, createDate, createSlotTimeLimits, sortEventChunks, isFunction, setContent, max, resourceBackgroundColor, resourceTextColor, bgEvent, helperEvent, ghostEvent, createEventClasses, createEventContent, toEventWithLocalDates, toViewWithLocalDates, task, keyEnter, datesEqual, outsideRange, addDuration, cloneDate, eventIntersects, createEventChunk, setPayload, rect, floor, ancestor, repositionEvent, height, runReposition, limitToRange, addDay, prepareEventChunks, debounce, toISOString, btnTextDay, themeView, btnTextWeek } from '@kokoro-calendar/core';
import { derived } from 'svelte/store';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { getContext, onMount, tick } from 'svelte';

function times(state) {
    return derived(
        [state.slotDuration, state._slotTimeLimits, state._intlSlotLabel],
        args => createTimes(setMidnight(createDate()), ...args)
    );
}

function slotTimeLimits(state) {
    return derived(
        [state.slotMinTime, state.slotMaxTime, state.flexibleSlotTimeLimits, state._viewDates, state._events],
        args => createSlotTimeLimits(...args)
    );
}

function groupEventChunks(chunks) {
    if (!chunks.length) {
        return;
    }

    sortEventChunks(chunks);

    // Group
    let group = {
        columns: [],
        end: chunks[0].end
    };
    for (let chunk of chunks) {
        let c = 0;
        if (chunk.start < group.end) {
            for (; c < group.columns.length; ++c) {
                if (group.columns[c].at(-1).end <= chunk.start) {
                    break;
                }
            }
            if (chunk.end > group.end) {
                group.end = chunk.end;
            }
        } else {
            group = {
                columns: [],
                end: chunk.end
            };
        }

        if (group.columns.length < c + 1) {
            group.columns.push([]);
        }
        group.columns[c].push(chunk);

        chunk.group = group;
        chunk.column = c;
    }
}

function createAllDayContent(allDayContent) {
    let text = 'all-day';
    let content;
    if (allDayContent) {
        content = isFunction(allDayContent) ? allDayContent({ text }) : allDayContent;
        if (typeof content === 'string') {
            content = { html: content };
        }
    } else {
        content = {
            html: text
        };
    }

    return content;
}

var root_1$2 = $.template(`<time></time>`);
var root$5 = $.template(`<div><div></div> <!></div> <div role="row"><div><!></div> <!></div>`, 1);

function Section($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $allDayContent = () => $.store_get(allDayContent, '$allDayContent', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_times = () => $.store_get(_times, '$_times', $$stores);
	let { allDayContent, theme, _times } = getContext('state');
	let allDayText = $.mutable_state();

	$.legacy_pre_effect(() => ($allDayContent()), () => {
		$.set(allDayText, createAllDayContent($allDayContent()));
	});

	$.legacy_pre_effect_reset();
	$.init();

	var fragment = root$5();
	var div = $.first_child(fragment);
	var div_1 = $.child(div);

	$.action(div_1, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(allDayText));

	var node = $.sibling(div_1, 2);

	$.each(node, 1, $_times, $.index, ($$anchor, time) => {
		var time_1 = root_1$2();

		$.action(time_1, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(time)[2] ? $.get(time)[1] : '');

		$.template_effect(() => {
			$.set_class(time_1, $theme().time);
			$.set_attribute(time_1, 'datetime', $.get(time)[0]);
		});

		$.append($$anchor, time_1);
	});

	$.reset(div);

	var div_2 = $.sibling(div, 2);
	var div_3 = $.child(div_2);
	var node_1 = $.child(div_3);

	$.slot(node_1, $$props, 'lines', {}, null);
	$.reset(div_3);

	var node_2 = $.sibling(div_3, 2);

	$.slot(node_2, $$props, 'default', {}, null);
	$.reset(div_2);

	$.template_effect(() => {
		$.set_class(div, $theme().sidebar);
		$.set_class(div_1, $theme().sidebarTitle);
		$.set_class(div_2, $theme().days);
		$.set_class(div_3, $theme().lines);
	});

	$.append($$anchor, fragment);
	$.pop();
	$$cleanup();
}

var root_4 = $.template(`<div></div>`);
var root$4 = $.template(`<div><div><!></div></div>`);

function Body($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $slotDuration = () => $.store_get(slotDuration, '$slotDuration', $$stores);
	const $_times = () => $.store_get(_times, '$_times', $$stores);
	const $_viewDates = () => $.store_get(_viewDates, '$_viewDates', $$stores);
	const $scrollTime = () => $.store_get(scrollTime, '$scrollTime', $$stores);
	const $_slotTimeLimits = () => $.store_get(_slotTimeLimits, '$_slotTimeLimits', $$stores);
	const $slotHeight = () => $.store_get(slotHeight, '$slotHeight', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);

	let {
		_bodyEl,
		_viewDates,
		_slotTimeLimits,
		_times,
		scrollTime,
		slotDuration,
		slotHeight,
		theme
	} = getContext('state');

	let el = $.mutable_state();
	let compact = $.mutable_state();
	let lines = $.mutable_state([]);

	function scrollToTime() {
		$.mutate(el, $.get(el).scrollTop = (($scrollTime().seconds - $_slotTimeLimits().min.seconds) / $slotDuration().seconds - 0.5) * $slotHeight());
	}

	$.legacy_pre_effect(() => ($.get(el)), () => {
		$.store_set(_bodyEl, $.get(el));
	});

	$.legacy_pre_effect(() => ($slotDuration(), $_times()), () => {
		$.set(compact, $slotDuration().seconds >= 3600);
		$.mutate(lines, $.get(lines).length = $_times().length);
	});

	$.legacy_pre_effect(
		() => (
			$.get(el),
			$_viewDates(),
			$scrollTime()
		),
		() => {
			if ($.get(el)) {
				$_viewDates();
				$scrollTime();
				scrollToTime();
			}
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var div = root$4();
	var div_1 = $.child(div);
	var node = $.child(div_1);

	Section(node, {
		children: ($$anchor, $$slotProps) => {
			var fragment = $.comment();
			var node_1 = $.first_child(fragment);

			$.slot(node_1, $$props, 'default', {}, null);
			$.append($$anchor, fragment);
		},
		$$slots: {
			default: true,
			lines: ($$anchor, $$slotProps) => {
				var fragment_1 = $.comment();
				var node_2 = $.first_child(fragment_1);

				$.each(node_2, 1, () => $.get(lines), $.index, ($$anchor, line) => {
					var div_2 = root_4();

					$.template_effect(() => $.set_class(div_2, $theme().line));
					$.append($$anchor, div_2);
				});

				$.append($$anchor, fragment_1);
			}
		}
	});

	$.reset(div_1);
	$.reset(div);
	$.bind_this(div, ($$value) => $.set(el, $$value), () => $.get(el));

	$.template_effect(() => {
		$.set_class(div, `${$theme().body ?? ''}${($.get(compact) ? ' ' + $theme().compact : '') ?? ''}`);
		$.set_class(div_1, $theme().content);
	});

	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

var root_1$1 = $.template(`<article><!> <div></div> <!></article>`);

function Event$1($$anchor, $$props) {
	$.push($$props, true);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $slotDuration = () => $.store_get(slotDuration, '$slotDuration', $$stores);
	const $_slotTimeLimits = () => $.store_get(_slotTimeLimits, '$_slotTimeLimits', $$stores);
	const $slotHeight = () => $.store_get(slotHeight, '$slotHeight', $$stores);
	const $resources = () => $.store_get(resources, '$resources', $$stores);
	const $eventBackgroundColor = () => $.store_get(eventBackgroundColor, '$eventBackgroundColor', $$stores);
	const $eventColor = () => $.store_get(eventColor, '$eventColor', $$stores);
	const $eventTextColor = () => $.store_get(eventTextColor, '$eventTextColor', $$stores);
	const $slotEventOverlap = () => $.store_get(slotEventOverlap, '$slotEventOverlap', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_iClasses = () => $.store_get(_iClasses, '$_iClasses', $$stores);
	const $eventClassNames = () => $.store_get(eventClassNames, '$eventClassNames', $$stores);
	const $_view = () => $.store_get(_view, '$_view', $$stores);
	const $displayEventEnd = () => $.store_get(displayEventEnd, '$displayEventEnd', $$stores);
	const $eventContent = () => $.store_get(eventContent, '$eventContent', $$stores);
	const $_intlEventTime = () => $.store_get(_intlEventTime, '$_intlEventTime', $$stores);
	const $eventDidMount = () => $.store_get(eventDidMount, '$eventDidMount', $$stores);
	const $eventAllUpdated = () => $.store_get(eventAllUpdated, '$eventAllUpdated', $$stores);
	const $eventClick = () => $.store_get(eventClick, '$eventClick', $$stores);
	const $_interaction = () => $.store_get(_interaction, '$_interaction', $$stores);
	const $eventMouseEnter = () => $.store_get(eventMouseEnter, '$eventMouseEnter', $$stores);
	const $eventMouseLeave = () => $.store_get(eventMouseLeave, '$eventMouseLeave', $$stores);
	const $eventWrapper = () => $.store_get(eventWrapper, '$eventWrapper', $$stores);

	const eventComponent = ($$anchor) => {
		var article = root_1$1();

		article.__click = function (...$$args) {
			$.get(onclick)?.apply(this, $$args);
		};

		var event_handler = $.derived(() => $.get(onclick) && keyEnter($.get(onclick)));

		article.__keydown = function (...$$args) {
			$.get(event_handler)?.apply(this, $$args);
		};

		var event_handler_1 = $.derived(() => createHandler($eventMouseEnter(), $.get(display)));
		var event_handler_2 = $.derived(() => createHandler($eventMouseLeave(), $.get(display)));
		var event_handler_3 = $.derived(() => !bgEvent($.get(display)) && !helperEvent($.get(display)) && createDragHandler($_interaction()));

		article.__pointerdown = function (...$$args) {
			$.get(event_handler_3)?.apply(this, $$args);
		};

		var node = $.child(article);
		const expression = $.derived(() => createDragHandler($_interaction(), ['y', 'start']));

		$.component(node, () => $.get(SvelteComponent), ($$anchor, $$component) => {
			$$component($$anchor, {
				start: true,
				get event() {
					return $.get(event);
				},
				get onpointerdown() {
					return $.get(expression);
				}
			});
		});

		var div = $.sibling(node, 2);

		$.action(div, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(content));

		var node_1 = $.sibling(div, 2);
		const expression_1 = $.derived(() => createDragHandler($_interaction(), ['y', 'end']));

		$.component(node_1, () => $.get(SvelteComponent), ($$anchor, $$component) => {
			$$component($$anchor, {
				get event() {
					return $.get(event);
				},
				get onpointerdown() {
					return $.get(expression_1);
				}
			});
		});

		$.reset(article);
		$.bind_this(article, ($$value) => el = $$value, () => el);

		$.template_effect(() => {
			$.set_class(article, $.get(classes));
			$.set_attribute(article, 'style', $.get(style));
			$.set_attribute(article, 'role', $.get(onclick) ? 'button' : undefined);
			$.set_attribute(article, 'tabindex', $.get(onclick) ? 0 : undefined);
			$.set_class(div, $theme().eventBody);
		});

		$.event('mouseenter', article, function (...$$args) {
			$.get(event_handler_1)?.apply(this, $$args);
		});

		$.event('mouseleave', article, function (...$$args) {
			$.get(event_handler_2)?.apply(this, $$args);
		});

		$.append($$anchor, article);
	};

	let {
		displayEventEnd,
		eventAllUpdated,
		eventBackgroundColor,
		eventTextColor,
		eventColor,
		eventContent,
		eventClick,
		eventDidMount,
		eventWrapper,
		eventClassNames,
		eventMouseEnter,
		eventMouseLeave,
		slotEventOverlap,
		slotDuration,
		slotHeight,
		resources,
		theme,
		_view,
		_intlEventTime,
		_interaction,
		_iClasses,
		_slotTimeLimits,
		_tasks
	} = getContext('state');

	let el;
	const event = $.derived(() => $$props.chunk.event);
	const display = $.derived(() => $.get(event).display);

	const style = $.derived(() => {
		// Style
		let step = $slotDuration().seconds;
		let offset = $_slotTimeLimits().min.seconds;
		let start = ($$props.chunk.start - $$props.date) / 1000;
		let end = ($$props.chunk.end - $$props.date) / 1000;
		let top = (start - offset) / step * $slotHeight();
		let height = max((end - start) / step * $slotHeight(), $slotHeight());
		let maxHeight = ($_slotTimeLimits().max.seconds - start) / step * $slotHeight();
		let bgColor = $.get(event).backgroundColor || resourceBackgroundColor($.get(event), $resources()) || $eventBackgroundColor() || $eventColor();
		let txtColor = $.get(event).textColor || resourceTextColor($.get(event), $resources()) || $eventTextColor();
		let style = `top:${top}px;` + `min-height:${height}px;` + `height:${height}px;` + `max-height:${maxHeight}px;`;

		if (bgColor) {
			style += `background-color:${bgColor};`;
		}

		if (txtColor) {
			style += `color:${txtColor};`;
		}

		if (!bgEvent($.get(display)) && !helperEvent($.get(display)) || ghostEvent($.get(display))) {
			style += `z-index:${$$props.chunk.column + 1};` + `left:${100 / $$props.chunk.group.columns.length * $$props.chunk.column}%;` + `width:${100 / $$props.chunk.group.columns.length * ($slotEventOverlap() ? 0.5 * (1 + $$props.chunk.group.columns.length - $$props.chunk.column) : 1)}%;`;
		}

		style += $.get(event).styles.join(';');
		return style;
	});

	const classes = $.derived(() => [
		bgEvent($.get(display)) ? $theme().bgEvent : $theme().event,
		...$_iClasses()([], $.get(event)),
		...createEventClasses($eventClassNames(), $.get(event), $_view())
	].join(' '));

	// Content
	const $$d = $.derived(() => createEventContent($$props.chunk, $displayEventEnd(), $eventContent(), $theme(), $_intlEventTime(), $_view())),
		timeText = $.derived(() => $.get($$d)[0]),
		content = $.derived(() => $.get($$d)[1]);

	onMount(() => {
		if (isFunction($eventDidMount())) {
			$eventDidMount()({
				event: toEventWithLocalDates($.get(event)),
				timeText: $.get(timeText),
				el,
				view: toViewWithLocalDates($_view())
			});
		}
	});

	$.user_effect(async () => {
		await tick();

		if (isFunction($eventAllUpdated()) && !helperEvent($.get(display))) {
			task(() => $eventAllUpdated()({ view: toViewWithLocalDates($_view()) }), 'eau', _tasks);
		}
	});

	function createHandler(fn, display) {
		return !helperEvent(display) && isFunction(fn)
			? (jsEvent) => fn({
				event: toEventWithLocalDates($.get(event)),
				el,
				jsEvent,
				view: toViewWithLocalDates($_view())
			})
			: undefined;
	}

	function createDragHandler(interaction, resize) {
		return interaction.action ? (jsEvent) => interaction.action.drag($.get(event), jsEvent, resize, undefined, undefined, $$props.chunk.zeroDuration) : undefined;
	}

	// Onclick handler
	const onclick = $.derived(() => !bgEvent($.get(display)) && createHandler($eventClick(), $.get(display)));
	const SvelteComponent = $.derived(() => $_interaction().resizer);
	var fragment = $.comment();
	var node_2 = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_3 = $.first_child(fragment_1);

			var render_arg = $.derived_safe_equal(() => ({
				event: $.get(event),
				timeText: $.get(timeText),
				view: toViewWithLocalDates($_view()),
				children: eventComponent
			}));

			$.snippet(node_3, $eventWrapper, () => $.get(render_arg));
			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			eventComponent($$anchor);
		};

		$.if(node_2, ($$render) => {
			if (isFunction($eventWrapper())) $$render(consequent); else $$render(alternate, false);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
	$$cleanup();
}

$.delegate(['click', 'keydown', 'pointerdown']);

var root$3 = $.template(`<div></div>`);

function NowIndicator($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $_now = () => $.store_get(_now, '$_now', $$stores);
	const $_today = () => $.store_get(_today, '$_today', $$stores);
	const $slotDuration = () => $.store_get(slotDuration, '$slotDuration', $$stores);
	const $_slotTimeLimits = () => $.store_get(_slotTimeLimits, '$_slotTimeLimits', $$stores);
	const $slotHeight = () => $.store_get(slotHeight, '$slotHeight', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);

	let {
		slotDuration,
		slotHeight,
		theme,
		_now,
		_today,
		_slotTimeLimits
	} = getContext('state');

	let start = $.mutable_state();
	let top = $.mutable_state(0);

	$.legacy_pre_effect(() => ($_now(), $_today()), () => {
		$.set(start, ($_now() - $_today()) / 1000 / 60);
	});

	$.legacy_pre_effect(
		() => (
			$slotDuration(),
			$_slotTimeLimits(),
			$.get(start),
			$slotHeight()
		),
		() => {
			// Style
			let step = $slotDuration().seconds / 60;
			let offset = $_slotTimeLimits().min.seconds / 60;

			$.set(top, ($.get(start) - offset) / step * $slotHeight());
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var div = root$3();

	$.template_effect(() => {
		$.set_class(div, $theme().nowIndicator);
		$.set_attribute(div, 'style', `top:${$.get(top) ?? ''}px`);
	});

	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

var root_3$2 = $.template(`<!> <!> <!>`, 1);
var root$2 = $.template(`<div role="cell"><div><!></div> <div><!></div> <div><!></div></div>`);

function Day$1($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $_today = () => $.store_get(_today, '$_today', $$stores);
	const $highlightedDates = () => $.store_get(highlightedDates, '$highlightedDates', $$stores);
	const $validRange = () => $.store_get(validRange, '$validRange', $$stores);
	const $_slotTimeLimits = () => $.store_get(_slotTimeLimits, '$_slotTimeLimits', $$stores);
	const $filterEventsWithResources = () => $.store_get(filterEventsWithResources, '$filterEventsWithResources', $$stores);
	const $resources = () => $.store_get(resources, '$resources', $$stores);
	const $_events = () => $.store_get(_events, '$_events', $$stores);
	const $_iEvents = () => $.store_get(_iEvents, '$_iEvents', $$stores);
	const $slotDuration = () => $.store_get(slotDuration, '$slotDuration', $$stores);
	const $slotHeight = () => $.store_get(slotHeight, '$slotHeight', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_interaction = () => $.store_get(_interaction, '$_interaction', $$stores);
	const $nowIndicator = () => $.store_get(nowIndicator, '$nowIndicator', $$stores);
	let date = $.prop($$props, 'date', 8);
	let resource = $.prop($$props, 'resource', 8, undefined);

	let {
		_events,
		_iEvents,
		highlightedDates,
		nowIndicator,
		slotDuration,
		slotHeight,
		filterEventsWithResources,
		theme,
		resources,
		validRange,
		_interaction,
		_today,
		_slotTimeLimits
	} = getContext('state');

	let el = $.mutable_state();

	let chunks = $.mutable_state(),
		bgChunks = $.mutable_state(),
		iChunks = $.mutable_state([]);

	let isToday = $.mutable_state(),
		highlight = $.mutable_state(),
		disabled = $.mutable_state();

	let resourceFilter = $.mutable_state();

	let start = $.mutable_state(),
		end = $.mutable_state();

	function dateFromPoint(x, y) {
		y -= rect($.get(el)).top;

		return {
			allDay: false,
			date: addDuration(addDuration(cloneDate(date()), $_slotTimeLimits().min), $slotDuration(), floor(y / $slotHeight())),
			resource: resource(),
			dayEl: $.get(el),
			disabled: $.get(disabled)
		};
	}

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$_today()
		),
		() => {
			$.set(isToday, datesEqual(date(), $_today()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$highlightedDates(),
			$.deep_read_state(date())
		),
		() => {
			$.set(highlight, $highlightedDates().some((d) => datesEqual(d, date())));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$validRange()
		),
		() => {
			$.set(disabled, outsideRange(date(), $validRange()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(disabled),
			$.deep_read_state(date()),
			$_slotTimeLimits()
		),
		() => {
			if (!$.get(disabled)) {
				$.set(start, addDuration(cloneDate(date()), $_slotTimeLimits().min));
				$.set(end, addDuration(cloneDate(date()), $_slotTimeLimits().max));
			}
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(resource()),
			$filterEventsWithResources(),
			$resources()
		),
		() => {
			$.set(resourceFilter, resource() ?? ($filterEventsWithResources() ? $resources() : undefined));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(disabled),
			$.get(chunks),
			$.get(bgChunks),
			$_events(),
			$.get(start),
			$.get(end),
			$.get(resourceFilter),
			groupEventChunks
		),
		() => {
			if (!$.get(disabled)) {
				$.set(chunks, []);
				$.set(bgChunks, []);

				for (let event of $_events()) {
					if ((!event.allDay || bgEvent(event.display)) && eventIntersects(event, $.get(start), $.get(end), $.get(resourceFilter))) {
						let chunk = createEventChunk(event, $.get(start), $.get(end));

						switch (event.display) {
							case 'background':
								$.get(bgChunks).push(chunk);
								break;

							default:
								$.get(chunks).push(chunk);
						}
					}
				}

				groupEventChunks($.get(chunks));
			}
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(disabled),
			$_iEvents(),
			$.get(start),
			$.get(end),
			$.deep_read_state(resource()),
			createEventChunk
		),
		() => {
			if (!$.get(disabled)) {
				$.set(iChunks, $_iEvents().map((event) => event && eventIntersects(event, $.get(start), $.get(end), resource()) ? createEventChunk(event, $.get(start), $.get(end)) : null));
			}
		}
	);

	$.legacy_pre_effect(() => ($.get(el), setPayload), () => {
		if ($.get(el)) {
			setPayload($.get(el), dateFromPoint);
		}
	});

	$.legacy_pre_effect_reset();
	$.init();

	var div = root$2();
	var div_1 = $.child(div);
	var node = $.child(div_1);

	{
		var consequent = ($$anchor) => {
			var fragment = $.comment();
			var node_1 = $.first_child(fragment);

			$.each(node_1, 1, () => $.get(bgChunks), (chunk) => chunk.event, ($$anchor, chunk) => {
				Event$1($$anchor, {
					get date() {
						return date();
					},
					get chunk() {
						return $.get(chunk);
					}
				});
			});

			$.append($$anchor, fragment);
		};

		$.if(node, ($$render) => {
			if (!$.get(disabled)) $$render(consequent);
		});
	}

	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var node_2 = $.child(div_2);

	{
		var consequent_3 = ($$anchor) => {
			var fragment_2 = root_3$2();
			var node_3 = $.first_child(fragment_2);

			{
				var consequent_1 = ($$anchor) => {
					Event$1($$anchor, {
						get date() {
							return date();
						},
						get chunk() {
							return $.get(iChunks)[1];
						}
					});
				};

				$.if(node_3, ($$render) => {
					if ($.get(iChunks)[1]) $$render(consequent_1);
				});
			}

			var node_4 = $.sibling(node_3, 2);

			$.each(node_4, 1, () => $.get(chunks), (chunk) => chunk.event, ($$anchor, chunk) => {
				Event$1($$anchor, {
					get date() {
						return date();
					},
					get chunk() {
						return $.get(chunk);
					}
				});
			});

			var node_5 = $.sibling(node_4, 2);

			{
				var consequent_2 = ($$anchor) => {
					Event$1($$anchor, {
						get date() {
							return date();
						},
						get chunk() {
							return $.get(iChunks)[0];
						}
					});
				};

				$.if(node_5, ($$render) => {
					if ($.get(iChunks)[0] && !$.get(iChunks)[0].event.allDay) $$render(consequent_2);
				});
			}

			$.append($$anchor, fragment_2);
		};

		$.if(node_2, ($$render) => {
			if (!$.get(disabled)) $$render(consequent_3);
		});
	}

	$.reset(div_2);

	var div_3 = $.sibling(div_2, 2);
	var node_6 = $.child(div_3);

	{
		var consequent_4 = ($$anchor) => {
			NowIndicator($$anchor, {});
		};

		$.if(node_6, ($$render) => {
			if ($nowIndicator() && $.get(isToday) && !$.get(disabled)) $$render(consequent_4);
		});
	}

	$.reset(div_3);
	$.reset(div);
	$.bind_this(div, ($$value) => $.set(el, $$value), () => $.get(el));

	$.template_effect(
		($0) => {
			$.set_class(div, `${$theme().day ?? ''} ${$0 ?? ''}${($.get(isToday) ? ' ' + $theme().today : '') ?? ''}${($.get(highlight) ? ' ' + $theme().highlight : '') ?? ''}${($.get(disabled) ? ' ' + $theme().disabled : '') ?? ''}`);
			$.set_class(div_1, $theme().bgEvents);
			$.set_class(div_2, $theme().events);
			$.set_class(div_3, $theme().extra);
		},
		[
			() => $theme().weekdays?.[date().getUTCDay()]
		],
		$.derived_safe_equal
	);

	$.event('pointerdown', div, function (...$$args) {
		(!$.get(disabled) ? $_interaction().action?.select : undefined)?.apply(this, $$args);
	});

	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

var root_1 = $.template(`<article><!> <div></div> <!></article>`);

function Event($$anchor, $$props) {
	$.push($$props, true);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $resources = () => $.store_get(resources, '$resources', $$stores);
	const $eventBackgroundColor = () => $.store_get(eventBackgroundColor, '$eventBackgroundColor', $$stores);
	const $eventColor = () => $.store_get(eventColor, '$eventColor', $$stores);
	const $eventTextColor = () => $.store_get(eventTextColor, '$eventTextColor', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_iClasses = () => $.store_get(_iClasses, '$_iClasses', $$stores);
	const $eventClassNames = () => $.store_get(eventClassNames, '$eventClassNames', $$stores);
	const $_view = () => $.store_get(_view, '$_view', $$stores);
	const $displayEventEnd = () => $.store_get(displayEventEnd, '$displayEventEnd', $$stores);
	const $eventContent = () => $.store_get(eventContent, '$eventContent', $$stores);
	const $_intlEventTime = () => $.store_get(_intlEventTime, '$_intlEventTime', $$stores);
	const $eventDidMount = () => $.store_get(eventDidMount, '$eventDidMount', $$stores);
	const $eventAllUpdated = () => $.store_get(eventAllUpdated, '$eventAllUpdated', $$stores);
	const $eventClick = () => $.store_get(eventClick, '$eventClick', $$stores);
	const $_interaction = () => $.store_get(_interaction, '$_interaction', $$stores);
	const $eventMouseEnter = () => $.store_get(eventMouseEnter, '$eventMouseEnter', $$stores);
	const $eventMouseLeave = () => $.store_get(eventMouseLeave, '$eventMouseLeave', $$stores);
	const $eventWrapper = () => $.store_get(eventWrapper, '$eventWrapper', $$stores);

	const eventComponent = ($$anchor) => {
		var article = root_1();

		article.__click = function (...$$args) {
			$.get(onclick)?.apply(this, $$args);
		};

		var event_handler = $.derived(() => $.get(onclick) && keyEnter($.get(onclick)));

		article.__keydown = function (...$$args) {
			$.get(event_handler)?.apply(this, $$args);
		};

		var event_handler_1 = $.derived(() => createHandler($eventMouseEnter(), $.get(display)));
		var event_handler_2 = $.derived(() => createHandler($eventMouseLeave(), $.get(display)));
		var event_handler_3 = $.derived(() => !helperEvent($.get(display)) && createDragHandler($_interaction()));

		article.__pointerdown = function (...$$args) {
			$.get(event_handler_3)?.apply(this, $$args);
		};

		var node = $.child(article);
		const expression = $.derived(() => createDragHandler($_interaction(), ['x', 'start']));

		$.component(node, () => $.get(SvelteComponent), ($$anchor, $$component) => {
			$$component($$anchor, {
				start: true,
				get event() {
					return $.get(event);
				},
				get onpointerdown() {
					return $.get(expression);
				}
			});
		});

		var div = $.sibling(node, 2);

		$.action(div, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(content));

		var node_1 = $.sibling(div, 2);
		const expression_1 = $.derived(() => createDragHandler($_interaction(), ['x', 'end']));

		$.component(node_1, () => $.get(SvelteComponent), ($$anchor, $$component) => {
			$$component($$anchor, {
				get event() {
					return $.get(event);
				},
				get onpointerdown() {
					return $.get(expression_1);
				}
			});
		});

		$.reset(article);
		$.bind_this(article, ($$value) => el = $$value, () => el);

		$.template_effect(() => {
			$.set_class(article, $.get(classes));
			$.set_attribute(article, 'style', $.get(style));
			$.set_attribute(article, 'role', $.get(onclick) ? 'button' : undefined);
			$.set_attribute(article, 'tabindex', $.get(onclick) ? 0 : undefined);
			$.set_class(div, $theme().eventBody);
		});

		$.event('mouseenter', article, function (...$$args) {
			$.get(event_handler_1)?.apply(this, $$args);
		});

		$.event('mouseleave', article, function (...$$args) {
			$.get(event_handler_2)?.apply(this, $$args);
		});

		$.append($$anchor, article);
	};

	let {
		displayEventEnd,
		eventAllUpdated,
		eventBackgroundColor,
		eventTextColor,
		eventClick,
		eventColor,
		eventContent,
		eventClassNames,
		eventDidMount,
		eventWrapper,
		eventMouseEnter,
		eventMouseLeave,
		resources,
		theme,
		_view,
		_intlEventTime,
		_interaction,
		_iClasses,
		_tasks
	} = getContext('state');

	let el;
	let event = $.derived(() => $$props.chunk.event);
	let margin = 1;
	const display = $.derived(() => $.get(event).display);

	const style = $.derived(() => {
		// Class & Style
		let bgColor = $.get(event).backgroundColor || resourceBackgroundColor($.get(event), $resources()) || $eventBackgroundColor() || $eventColor();
		let txtColor = $.get(event).textColor || resourceTextColor($.get(event), $resources()) || $eventTextColor();
		let style = '';

		if (bgEvent($.get(display))) {
			style = `width:calc(${$$props.chunk.days * 100}% + ${$$props.chunk.days - 1}px);`;
		} else {
			style = `width:calc(${$$props.chunk.days * 100}% + ${($$props.chunk.days - 1) * 7}px);` + `margin-top:${$.get(event)._margin ?? margin}px;`;
		}

		if (bgColor) {
			style += `background-color:${bgColor};`;
		}

		if (txtColor) {
			style += `color:${txtColor};`;
		}

		style += $.get(event).styles.join(';');
		return style;
	});

	const classes = $.derived(() => [
		bgEvent($.get(display)) ? $theme().bgEvent : $theme().event,
		...$_iClasses()([], $.get(event)),
		...createEventClasses($eventClassNames(), $.get(event), $_view())
	].join(' '));

	// Content
	const $$d = $.derived(() => createEventContent($$props.chunk, $displayEventEnd(), $eventContent(), $theme(), $_intlEventTime(), $_view())),
		timeText = $.derived(() => $.get($$d)[0]),
		content = $.derived(() => $.get($$d)[1]);

	onMount(() => {
		if (isFunction($eventDidMount())) {
			$eventDidMount()({
				event: toEventWithLocalDates($.get(event)),
				timeText: $.get(timeText),
				el,
				view: toViewWithLocalDates($_view())
			});
		}
	});

	$.user_effect(async () => {
		await tick();

		if (isFunction($eventAllUpdated()) && !helperEvent($.get(display))) {
			task(() => $eventAllUpdated()({ view: toViewWithLocalDates($_view()) }), 'eau', _tasks);
		}
	});

	function createHandler(fn, display) {
		return !helperEvent(display) && isFunction(fn)
			? (jsEvent) => fn({
				event: toEventWithLocalDates($.get(event)),
				el,
				jsEvent,
				view: toViewWithLocalDates($_view())
			})
			: undefined;
	}

	function createDragHandler(interaction, resize) {
		return interaction.action ? (jsEvent) => interaction.action.drag($.get(event), jsEvent, resize, null, rect(el).top - rect(ancestor(el, 1)).top, $$props.chunk.zeroDuration) : undefined;
	}

	function reposition() {
		if (!el) {
			return;
		}

		margin = repositionEvent($$props.chunk, $$props.longChunks, height(el));
	}

	// Onclick handler
	const onclick = $.derived(() => createHandler($eventClick(), $.get(display)));
	const SvelteComponent = $.derived(() => $_interaction().resizer);
	var fragment = $.comment();
	var node_2 = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_3 = $.first_child(fragment_1);

			var render_arg = $.derived_safe_equal(() => ({
				event: $.get(event),
				timeText: $.get(timeText),
				view: toViewWithLocalDates($_view()),
				children: eventComponent
			}));

			$.snippet(node_3, $eventWrapper, () => $.get(render_arg));
			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			eventComponent($$anchor);
		};

		$.if(node_2, ($$render) => {
			if (isFunction($eventWrapper())) $$render(consequent); else $$render(alternate, false);
		});
	}

	$.append($$anchor, fragment);

	var $$pop = $.pop({ reposition });

	$$cleanup();
	return $$pop;
}

$.delegate(['click', 'keydown', 'pointerdown']);

var root_3$1 = $.template(`<div><!></div>`);
var root$1 = $.template(`<div role="cell"><div><!></div> <!> <div><!></div></div>`);

function Day($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $_today = () => $.store_get(_today, '$_today', $$stores);
	const $highlightedDates = () => $.store_get(highlightedDates, '$highlightedDates', $$stores);
	const $validRange = () => $.store_get(validRange, '$validRange', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_interaction = () => $.store_get(_interaction, '$_interaction', $$stores);
	let date = $.prop($$props, 'date', 8);
	let chunks = $.prop($$props, 'chunks', 8);
	let bgChunks = $.prop($$props, 'bgChunks', 8);
	let longChunks = $.prop($$props, 'longChunks', 8);
	let iChunks = $.prop($$props, 'iChunks', 24, () => []);
	let resource = $.prop($$props, 'resource', 8, undefined);

	let {
		highlightedDates,
		theme,
		validRange,
		_interaction,
		_today
	} = getContext('state');

	let el = $.mutable_state();

	let dayChunks = $.mutable_state(),
		dayBgChunks = $.mutable_state();

	let isToday = $.mutable_state(),
		highlight = $.mutable_state(),
		disabled = $.mutable_state();

	let refs = $.mutable_state([]);

	function reposition() {
		if (!$.get(disabled)) {
			runReposition($.get(refs), $.get(dayChunks));
		}
	}

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(chunks()),
			$.deep_read_state(date())
		),
		() => {
			$.set(dayChunks, chunks().filter((chunk) => datesEqual(chunk.date, date())));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(bgChunks()),
			$.deep_read_state(date())
		),
		() => {
			$.set(dayBgChunks, bgChunks().filter((bgChunk) => datesEqual(bgChunk.date, date())));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$_today()
		),
		() => {
			$.set(isToday, datesEqual(date(), $_today()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$highlightedDates(),
			$.deep_read_state(date())
		),
		() => {
			$.set(highlight, $highlightedDates().some((d) => datesEqual(d, date())));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$validRange()
		),
		() => {
			$.set(disabled, outsideRange(date(), $validRange()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(el),
			$.deep_read_state(date()),
			$.deep_read_state(resource()),
			$.get(disabled)
		),
		() => {
			if ($.get(el)) {
				setPayload($.get(el), () => ({
					allDay: true,
					date: date(),
					resource: resource(),
					dayEl: $.get(el),
					disabled: $.get(disabled)
				}));
			}
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var div = root$1();
	var div_1 = $.child(div);
	var node = $.child(div_1);

	{
		var consequent = ($$anchor) => {
			var fragment = $.comment();
			var node_1 = $.first_child(fragment);

			$.each(node_1, 1, () => $.get(dayBgChunks), (chunk) => chunk.event, ($$anchor, chunk) => {
				Event($$anchor, {
					get chunk() {
						return $.get(chunk);
					}
				});
			});

			$.append($$anchor, fragment);
		};

		$.if(node, ($$render) => {
			if (!$.get(disabled)) $$render(consequent);
		});
	}

	$.reset(div_1);

	var node_2 = $.sibling(div_1, 2);

	{
		var consequent_1 = ($$anchor) => {
			var div_2 = root_3$1();
			var node_3 = $.child(div_2);

			Event(node_3, {
				get chunk() {
					return iChunks()[0];
				}
			});

			$.reset(div_2);
			$.template_effect(() => $.set_class(div_2, `${$theme().events ?? ''} ${$theme().preview ?? ''}`));
			$.append($$anchor, div_2);
		};

		$.if(node_2, ($$render) => {
			if (iChunks()[0] && datesEqual(iChunks()[0].date, date()) && !$.get(disabled)) $$render(consequent_1);
		});
	}

	var div_3 = $.sibling(node_2, 2);
	var node_4 = $.child(div_3);

	{
		var consequent_2 = ($$anchor) => {
			var fragment_2 = $.comment();
			var node_5 = $.first_child(fragment_2);

			$.each(node_5, 3, () => $.get(dayChunks), (chunk) => chunk.event, ($$anchor, chunk, i) => {
				$.bind_this(
					Event($$anchor, {
						get chunk() {
							return $.get(chunk);
						},
						get longChunks() {
							return longChunks();
						},
						$$legacy: true
					}),
					($$value, i) => $.mutate(refs, $.get(refs)[i] = $$value),
					(i) => $.get(refs)?.[i],
					() => [$.get(i)]
				);
			});

			$.append($$anchor, fragment_2);
		};

		$.if(node_4, ($$render) => {
			if (!$.get(disabled)) $$render(consequent_2);
		});
	}

	$.reset(div_3);
	$.reset(div);
	$.bind_this(div, ($$value) => $.set(el, $$value), () => $.get(el));

	$.template_effect(
		($0) => {
			$.set_class(div, `${$theme().day ?? ''} ${$0 ?? ''}${($.get(isToday) ? ' ' + $theme().today : '') ?? ''}${($.get(highlight) ? ' ' + $theme().highlight : '') ?? ''}${($.get(disabled) ? ' ' + $theme().disabled : '') ?? ''}`);
			$.set_class(div_1, $theme().bgEvents);
			$.set_class(div_3, $theme().events);
		},
		[
			() => $theme().weekdays?.[date().getUTCDay()]
		],
		$.derived_safe_equal
	);

	$.event('pointerdown', div, function (...$$args) {
		(!$.get(disabled) ? $_interaction().action?.select : undefined)?.apply(this, $$args);
	});

	$.append($$anchor, div);
	$.bind_prop($$props, 'reposition', reposition);

	var $$pop = $.pop({ reposition });

	$$cleanup();
	return $$pop;
}

function Week($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $validRange = () => $.store_get(validRange, '$validRange', $$stores);
	const $filterEventsWithResources = () => $.store_get(filterEventsWithResources, '$filterEventsWithResources', $$stores);
	const $resources = () => $.store_get(resources, '$resources', $$stores);
	const $_events = () => $.store_get(_events, '$_events', $$stores);
	const $hiddenDays = () => $.store_get(hiddenDays, '$hiddenDays', $$stores);
	const $_iEvents = () => $.store_get(_iEvents, '$_iEvents', $$stores);
	let dates = $.prop($$props, 'dates', 8);
	let resource = $.prop($$props, 'resource', 8, undefined);

	let {
		_events,
		_iEvents,
		_queue2,
		hiddenDays,
		resources,
		filterEventsWithResources,
		validRange
	} = getContext('state');

	let chunks = $.mutable_state(),
		bgChunks = $.mutable_state(),
		longChunks = $.mutable_state(),
		iChunks = $.mutable_state([]);

	let start = $.mutable_state();
	let end = $.mutable_state();
	let refs = $.mutable_state([]);
	let resourceFilter = $.mutable_state();
	let debounceHandle = {};

	function reposition() {
		debounce(() => runReposition($.get(refs), dates()), debounceHandle, _queue2);
	}

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(dates()),
			$validRange(),
			cloneDate
		),
		() => {
			$.set(start, limitToRange(dates()[0], $validRange()));
			$.set(end, addDay(cloneDate(limitToRange(dates().at(-1), $validRange()))));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(resource()),
			$filterEventsWithResources(),
			$resources()
		),
		() => {
			$.set(resourceFilter, resource() ?? ($filterEventsWithResources() ? $resources() : undefined));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(chunks),
			$.get(bgChunks),
			$_events(),
			$.get(start),
			$.get(end),
			$.get(resourceFilter),
			$hiddenDays()
		),
		() => {
			$.set(chunks, []);
			$.set(bgChunks, []);

			for (let event of $_events()) {
				if (event.allDay && eventIntersects(event, $.get(start), $.get(end), $.get(resourceFilter))) {
					let chunk = createEventChunk(event, $.get(start), $.get(end));

					if (bgEvent(event.display)) {
						$.get(bgChunks).push(chunk);
					} else {
						$.get(chunks).push(chunk);
					}
				}
			}

			prepareEventChunks($.get(bgChunks), $hiddenDays());
			$.set(longChunks, prepareEventChunks($.get(chunks), $hiddenDays()));
			// Run reposition only when events get changed
			reposition();
		}
	);

	$.legacy_pre_effect(
		() => (
			$_iEvents(),
			$.get(start),
			$.get(end),
			$.deep_read_state(resource()),
			$hiddenDays()
		),
		() => {
			$.set(iChunks, $_iEvents().map((event) => {
				let chunk;

				if (event && event.allDay && eventIntersects(event, $.get(start), $.get(end), resource())) {
					chunk = createEventChunk(event, $.get(start), $.get(end));
					prepareEventChunks([chunk], $hiddenDays());
				} else {
					chunk = null;
				}

				return chunk;
			}));
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var fragment = $.comment();

	$.event('resize', $.window, reposition);

	var node = $.first_child(fragment);

	$.each(node, 1, dates, $.index, ($$anchor, date, i) => {
		$.bind_this(
			Day($$anchor, {
				get date() {
					return $.get(date);
				},
				get chunks() {
					return $.get(chunks);
				},
				get bgChunks() {
					return $.get(bgChunks);
				},
				get longChunks() {
					return $.get(longChunks);
				},
				get iChunks() {
					return $.get(iChunks);
				},
				get resource() {
					return resource();
				},
				$$legacy: true
			}),
			($$value, i) => $.mutate(refs, $.get(refs)[i] = $$value),
			(i) => $.get(refs)?.[i],
			() => [i]
		);
	});

	$.append($$anchor, fragment);
	$.pop();
	$$cleanup();
}

var root_2 = $.template(`<div role="columnheader"><time></time></div>`);
var root_3 = $.template(`<div><div><!> <div></div></div></div>`);
var root = $.template(`<div><!> <div></div></div> <!> <!>`, 1);

function View($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_viewDates = () => $.store_get(_viewDates, '$_viewDates', $$stores);
	const $_intlDayHeaderAL = () => $.store_get(_intlDayHeaderAL, '$_intlDayHeaderAL', $$stores);
	const $_intlDayHeader = () => $.store_get(_intlDayHeader, '$_intlDayHeader', $$stores);
	const $allDaySlot = () => $.store_get(allDaySlot, '$allDaySlot', $$stores);

	let {
		_viewDates,
		_intlDayHeader,
		_intlDayHeaderAL,
		allDaySlot,
		theme
	} = getContext('state');

	$.init();

	var fragment = root();
	var div = $.first_child(fragment);
	var node = $.child(div);

	Section(node, {
		children: ($$anchor, $$slotProps) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			$.each(node_1, 1, $_viewDates, $.index, ($$anchor, date) => {
				var div_1 = root_2();
				var time = $.child(div_1);

				$.action(time, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $_intlDayHeader().format($.get(date)));
				$.reset(div_1);

				$.template_effect(
					($0, $1, $2) => {
						$.set_class(div_1, `${$theme().day ?? ''} ${$0 ?? ''}`);
						$.set_attribute(time, 'datetime', $1);
						$.set_attribute(time, 'aria-label', $2);
					},
					[
						() => $theme().weekdays?.[$.get(date).getUTCDay()],
						() => toISOString($.get(date), 10),
						() => $_intlDayHeaderAL().format($.get(date))
					],
					$.derived_safe_equal
				);

				$.append($$anchor, div_1);
			});

			$.append($$anchor, fragment_1);
		},
		$$slots: { default: true }
	});

	var div_2 = $.sibling(node, 2);

	$.reset(div);

	var node_2 = $.sibling(div, 2);

	{
		var consequent = ($$anchor) => {
			var div_3 = root_3();
			var div_4 = $.child(div_3);
			var node_3 = $.child(div_4);

			Section(node_3, {
				children: ($$anchor, $$slotProps) => {
					Week($$anchor, {
						get dates() {
							return $_viewDates();
						}
					});
				},
				$$slots: { default: true }
			});

			var div_5 = $.sibling(node_3, 2);

			$.reset(div_4);
			$.reset(div_3);

			$.template_effect(() => {
				$.set_class(div_3, $theme().allDay);
				$.set_class(div_4, $theme().content);
				$.set_class(div_5, $theme().hiddenScroll);
			});

			$.append($$anchor, div_3);
		};

		$.if(node_2, ($$render) => {
			if ($allDaySlot()) $$render(consequent);
		});
	}

	var node_4 = $.sibling(node_2, 2);

	Body(node_4, {
		children: ($$anchor, $$slotProps) => {
			var fragment_3 = $.comment();
			var node_5 = $.first_child(fragment_3);

			$.each(node_5, 1, $_viewDates, $.index, ($$anchor, date) => {
				Day$1($$anchor, {
					get date() {
						return $.get(date);
					}
				});
			});

			$.append($$anchor, fragment_3);
		},
		$$slots: { default: true }
	});

	$.template_effect(() => {
		$.set_class(div, $theme().header);
		$.set_class(div_2, $theme().hiddenScroll);
	});

	$.append($$anchor, fragment);
	$.pop();
	$$cleanup();
}

var index = {
	createOptions(options) {
		// Common options
		options.buttonText.timeGridDay = 'day';
		options.buttonText.timeGridWeek = 'week';
		options.view = 'timeGridWeek';
		options.views.timeGridDay = {
			buttonText: btnTextDay,
			component: View,
			dayHeaderFormat: { weekday: 'long' },
			duration: { days: 1 },
			theme: themeView('ec-time-grid ec-day-view'),
			titleFormat: { year: 'numeric', month: 'long', day: 'numeric' }
		};
		options.views.timeGridWeek = {
			buttonText: btnTextWeek,
			component: View,
			duration: { weeks: 1 },
			theme: themeView('ec-time-grid ec-week-view')
		};
	},

	createStores(state) {
		state._slotTimeLimits = slotTimeLimits(state);  // flexible limits
		state._times = times(state);
	}
};

export { Body, Day$1 as Day, Section, Week, index as default };
